import { size } from "polished";
import styled, { css } from "styled-components";
import ArrowLeftDoubleIcon from "../../img/icons/arrow-double-left.svg?react";
import ArrowRightDoubleIcon from "../../img/icons/arrow-double-right.svg?react";
import ArrowHyphenIcon from "../../img/icons/arrow-hyphen.svg?react";
import ArrowLeftIcon from "../../img/icons/arrow-left.svg?react";
import ArrowRightIcon from "../../img/icons/arrow-right.svg?react";

interface IArrow {
  color?: string;
}

const rtlStyles = css`
  [dir="rtl"] & {
    transform: scaleX(-1);
  }
`;

export const ArrowLeft = styled(ArrowLeftIcon)<IArrow>`
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
  ${rtlStyles}
`;

export const ArrowRight = styled(ArrowRightIcon)<IArrow>`
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
  ${rtlStyles}
`;

export const ArrowLeftDouble = styled(ArrowLeftDoubleIcon)<IArrow>`
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
  ${rtlStyles}
`;

export const ArrowRightDouble = styled(ArrowRightDoubleIcon)<IArrow>`
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
  ${rtlStyles}
`;

export const ControlArrowRight = styled(ArrowRight)`
  ${size("16px")};
  margin-inline-start: 0.5rem;
  vertical-align: middle;
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
  ${rtlStyles}
`;

export const ControlArrowLeft = styled(ArrowLeft)`
  ${size("16px")};
  margin-inline-end: 0.5rem;
  vertical-align: middle;
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
  ${rtlStyles}
`;

export const ArrowHyphen = styled(ArrowHyphenIcon)`
  vertical-align: middle;
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;
